<div [ngSwitch]="type">
  <div *ngSwitchCase="'group'">
    <div class="custom-dropdown">
      <div class="dropdown-label" [ngClass]="{'disabled': disabled}" (click)="toggleDropdown()" role="button"  tabindex="-1">
        <span class="label-text">
          {{ selectedLabel ? selectedLabel : (placeholder ? placeholder : ('dropdown.placeholder' | translate)) }}
        </span>
        <i *ngIf="selectedLabel" class="bi bi-x-square-fill reset-icon" (click)="reset()" role="button"  tabindex="-1"
           style="position: absolute; right: 2rem;"></i>
        <span class="dropdown-icon">&#9662;</span>
      </div>
      <div class="dropdown-menu" *ngIf="isOpen">
        <div class="filter-input" *ngIf="filter">
          <input
            type="text"
            [(ngModel)]="searchText"
            [placeholder]="('dropdown.filter.placeholder' | translate)"
            class="form-control"
            (input)="filterGroupOptions()"
          />
        </div>
        <div *ngFor="let group of filteredOptions" class="dropdown-list-items">
          <div class="dropdown-group-label">{{ group.label }}</div>
          <div
            *ngFor="let option of group.items"
            [ngClass]="{ selected: selectedValue === option.value }"
            class="dropdown-group-option"
            (click)="selectGroupOption(option,group)" role="button"  tabindex="-1"
          >
            {{ option.label }}
          </div>
        </div>
      </div>
    </div>
  </div>
  <div *ngSwitchCase="'single'">
    <div class="custom-dropdown">
      <div class="dropdown-label" [ngClass]="{'disabled': disabled}" (click)="toggleDropdown()" role="button"  tabindex="-1">
        <span class="label-text">
          {{ selectedLabel ? selectedLabel : (placeholder ? placeholder : ('dropdown.placeholder' | translate)) }}
        </span>
        <i *ngIf="selectedLabel" class="bi bi-x-square-fill reset-icon" (click)="reset()" role="button"  tabindex="-1"
           style="position: absolute; right: 2rem;"></i>
        <span class="dropdown-icon">&#9662;</span>
      </div>
      <div class="dropdown-menu" *ngIf="isOpen">
        <div class="filter-input" *ngIf="filter">
          <input
            type="text"
            [(ngModel)]="searchText"
            [placeholder]="('dropdown.filter.placeholder' | translate)"
            class="form-control"
            (input)="filterOptions()"
          />
        </div>
        <div class="dropdown-list-items">
          <div
            *ngFor="let option of filteredOptions"
            [ngClass]="{ selected: selectedValue === option.value }"
            class="dropdown-option"
            (click)="selectOption(option)" role="button"  tabindex="-1"
          >
            {{ option.label }}
          </div>
        </div>
      </div>
    </div>
  </div>
  <div *ngSwitchCase="'string'">
    <div class="custom-dropdown">
      <div class="dropdown-label" [ngClass]="{'disabled': disabled}" (click)="toggleDropdown()" role="button"  tabindex="-1">
        <span class="label-text">
          {{ selectedLabel ? selectedLabel : (placeholder ? placeholder : ('dropdown.placeholder' | translate)) }}
        </span>
        <i *ngIf="selectedLabel" class="bi bi-x-square-fill reset-icon" (click)="reset()" role="button"  tabindex="-1"
           style="position: absolute; right: 2rem;"></i>
        <span class="dropdown-icon">&#9662;</span>
      </div>
      <div class="dropdown-menu" *ngIf="isOpen">
        <div class="filter-input" *ngIf="filter">
          <input
            type="text"
            [(ngModel)]="searchText"
            [placeholder]="('dropdown.filter.placeholder' | translate)"
            class="form-control"
            (input)="filterOptions()"
          />
        </div>
        <div class="dropdown-list-items">
          <div
            *ngFor="let option of filteredOptions"
            [ngClass]="{ selected: selectedValue === option }"
            class="dropdown-option"
            (click)="selectStringOption(option)" role="button"  tabindex="-1"
          >
            {{ option }}
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
